// Catch-all — renders the legacy NotFound page directly (post 2.4b cutover).
import { createFileRoute } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";

export const Route = createFileRoute("/$")({
  head: () => ({
    meta: [
      { title: "Página no encontrada | Fora da Rota" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: NotFound,
});
